<div class="tag" [ngClass]="hostClasses" [attr.aria-disabled]="disabled">
  @if (icon && iconPosition === 'left') {
    <span class="material-symbols-outlined">{{ icon }}</span>
  }

  <ng-content></ng-content>

  @if (icon && iconPosition === 'right') {
    <span class="material-symbols-outlined">{{ icon }}</span>
  }
</div>
